/**
 * This file is auto-generated from validators.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const invalidEmail: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Adres e-mail jest nieprawidłowy';
        case 'en':
            return 'Email address is invalid';
        case 'de':
            return 'E-Mail-Adresse ist ungültig';
    }
};

export const minLengthNotMet: Translation<{ minLength: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Minimalna długość to ', params.minLength, ' znaków'];
        case 'en':
            return ['Minimum length is ', params.minLength, ' characters'];
        case 'de':
            return ['Mindestlänge beträgt ', params.minLength, ' Zeichen'];
    }
};

export const maxLengthExceeded: Translation<{ maxLength: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Maksymalna długość to ', params.maxLength, ' znaków'];
        case 'en':
            return ['Maximum length is ', params.maxLength, ' characters'];
        case 'de':
            return ['Maximale Länge beträgt ', params.maxLength, ' Zeichen'];
    }
};

export const minValueNotMet: Translation<{ minValue: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Minimalna wartość to ', params.minValue];
        case 'en':
            return ['Minimum value is ', params.minValue];
        case 'de':
            return ['Mindestwert beträgt ', params.minValue];
    }
};

export const maxValueExceeded: Translation<{ maxValue: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Maksymalna wartość to ', params.maxValue];
        case 'en':
            return ['Maximum value is ', params.maxValue];
        case 'de':
            return ['Maximalwert beträgt ', params.maxValue];
    }
};

export const maxDateExceeded: Translation<{ maxDate: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Data nie może być późniejsza niż ', params.maxDate];
        case 'en':
            return ['Date cannot be later than ', params.maxDate];
        case 'de':
            return ['Datum darf nicht später als ', params.maxDate, ' sein'];
    }
};

export const minDateNotMet: Translation<{ minDate: unknown }> = (lang, params) => {
    switch (lang) {
        case 'pl':
            return ['Data nie może być wcześniejsza niż ', params.minDate];
        case 'en':
            return ['Date cannot be earlier than ', params.minDate];
        case 'de':
            return ['Datum darf nicht früher als ', params.minDate, ' sein'];
    }
};

export const invalidPhoneNumber: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Numer telefonu jest niepoprawny';
        case 'en':
            return 'Phone number is invalid';
        case 'de':
            return 'Telefonnummer ist ungültig';
    }
};

export const invalidPostCode: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Kod pocztowy jest niepoprawny';
        case 'en':
            return 'Postal code is invalid';
        case 'de':
            return 'Postleitzahl ist ungültig';
    }
};

export const invalidFormat: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Nieprawidłowy format';
        case 'en':
            return 'Invalid format';
        case 'de':
            return 'Ungültiges Format';
    }
};

export const required: Translation = lang => {
    switch (lang) {
        case 'pl':
            return 'Pole jest wymagane';
        case 'en':
            return 'Field is required';
        case 'de':
            return 'Feld ist erforderlich';
    }
};
